import { Component, OnInit } from '@angular/core';
import { MdDialogRef } from '@angular/material';

@Component({
  selector: 'app-credit-not-configured-dialog',
  templateUrl: './credit-not-configured-dialog.component.html',
  styleUrls: ['./credit-not-configured-dialog.component.scss']
})
export class CreditNotConfiguredDialogComponent{

  constructor(private dialogRef: MdDialogRef<CreditNotConfiguredDialogComponent>) { }

  closeDialog(){
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/creditos/credit-not-configured-dialog/credit-not-configured-dialog.component.ts